import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';
import { motion } from 'framer-motion';

export const Wrapper = styled.div`
  grid-area: table;
  position: relative;

  @media (min-width: ${breakpoints.desktop}) {
    display: block;
  }
`;

export const Header = styled.div`
display: grid;
grid-template-areas: 'title right'; 
grid-template-columns: 50% 50%;
`;

export const Title = styled.h3`
  font-weight: lighter;
  padding: 15px 0;
  font-size: 1.4rem;
  margin:0 15px;
  grid-area: title;
  text-align: left;
  
 span {
  color: #ea0709
  }
  
  @media (min-width: ${breakpoints.desktop}) {
    margin:0 30px;
  }
`;

export const LeftActions = styled.div`
  grid-area: left;
`;

export const RightActions = styled.div`
  flex: 1;
  flex-direction: column;
  grid-area: right;
  
  @media (min-width: ${breakpoints.desktop}) {
    display: none;
  }
`;


export const RightAction = styled.div`
  cursor: pointer;
  margin: 10px 10px 10px 0;
`;

export const Table = styled.div`
  border: 0;
  padding: 0;
  
  border-collapse: collapse;
  display: table;
  
  @media (min-width: ${breakpoints.desktop}) {
    width: calc(100% - 60px);
    margin:0 30px;
  }
`;

export const Lightbox = styled.div`
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background-color: black;
  opacity: 0.8;
  z-index: 99;
`;

export const TableHead = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const TableHeadText = styled.p`
  font-size: 14px;
  margin: 10px 5px 10px 5px;
`;

export const Row = styled.div`
  padding: 0;
  display: table-row;
  background-color: white;
  color: black;
  margin: 10px;
  border-bottom: 10px black solid;
  
  &:first-child {
    background-color: black;
    ${(props) => props.highlight && 'background-color:white;z-index: 999;position: relative'};
  }
  
  .CircularProgressbar .CircularProgressbar-text {
    fill: black!important;
  }
  
  ${(props) => props.gridView && `
    float: left;
    display: block;
    width: calc(20% - 30px);   
    height: 180px; 
    margin: 15px;
    position: relative;
  `}
`;

export const MotionContainer = styled(motion.div)`
  width: 100%;
`;

export const Column = styled.div`
  font-size: 0.9rem;
  border-bottom: 1px #808080 solid;
  padding: 5px 0 0 0;
  margin: 0;
  display: table-cell;
  justify-content: center;
  vertical-align: middle;
  
  ${(props) => props.gridView && `
    float: left;
    display: inline;
    border-bottom: 0;
    width: 100%;
    text-align: left;
    font-size: 0.9rem;
  `}
`;

export const Thumbnail = styled.img`
  border: 0;
  width: 100%;
  
  @media (min-width: ${breakpoints.desktop}) {
    display: inline-block;
    width: 100px;
    cursor: pointer;
  }
`;

export const ScoreWrapper = styled.div`
  align-self: center;
  align-items: center;
  justify-content: center;

.CircularProgressbar .CircularProgressbar-text {
    color: black;
    fill: black;
    font-size: 30px;
  }

  
  @media (min-width: ${breakpoints.desktop}) {
    display: block;
    margin-left: 85px;
    width: 45px;
      
    .CircularProgressbar .CircularProgressbar-text {
      font-size: 30px;
      color: white;
      fill: white;
    }
  }
  
  .CircularProgressbar .CircularProgressbar-path {
    stroke: ${(props) => props.color};
  }
  
  ${(props) => props.gridView && `
    width: 45px;
    position: absolute;
    top: 10px;
    right: 10px;
  `}
  
`;

/** Mobile * */
export const MobileRow = styled.div`
  background-color: white;
  margin: 10px 10px;
  text-align: left;
  display: grid;
  grid-template-columns: 40% auto 15%;
  grid-template-areas: 'thumb content score'; 
`;

export const MobileThumb = styled.div`
  grid-area: thumb;
  margin: 10px 10px 5px 10px;
`;

export const MobileColumn = styled.div`
  grid-area: content;
  margin: 10px 0;
`;

export const MobileText = styled.p`
  color: black;
  margin: 0;
  
  span {
    font-weight: bold;
  }

  ${(props) => props.indent && `
    padding-left: 10px;
  `}
  
`;

export const MobileScore = styled.div`
  grid-area: score;
  margin: 10px 10px;
`;

export const Error = styled.div`
  justify-content: center;
  align-items: center;
  margin: 50px;
`;

export const CRBreakdown = styled.p`
  color: black;
  text-align: center;
`;

export const AdditionalInfo = styled.p`
  font-size: .7em;
  ${(props) => props.visible && `
    visibility: hidden;
  `}
`;

/* tooltip engine score styles */
export const TooltipText = styled.p`
  color: #fff;
  width: 200px;
  text-align: center;
  line-height: 44px;
  border-radius: 3px;
  cursor: pointer;
`;
export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 30px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: 150px;
  padding: 5px 5px;
  border-radius: 4px;

  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;

  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 40px;
    top: -10px;
    position: absolute;

    border: 10px solid transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
  }
`;
export const TooltipCard = styled.div`
  position: relative;
  & ${TooltipText}:hover + ${TooltipBox} {
    visibility: visible;
    color: #fff;
    background-color: rgba(189, 0, 0, 1);
    width: 170px;
    padding: 8px 8px;

    &:before {
      border-color: transparent transparent rgba(189, 0, 0, 1)
        rgba(0, 0, 0, 0.8);
    }
  }
`;
